import { addRoute } from "~/app/routes"
require("~/features/browser-compatibility-error/BrowserCompatibilityError.routes").default(addRoute);
require("~/features/debug-devices/DebugDevices.routes").default(addRoute);
require("~/features/disconnection-page/DisconnectionPage.routes").default(addRoute);
require("~/features/generic-error/GenericError.routes").default(addRoute);
require("~/features/home/Home.routes").default(addRoute);
require("~/features/test-mode/TestMode.routes").default(addRoute);
require("~/features/video-call/VideoCall.routes").default(addRoute);